<template>
  <div class="el-collapse-item"
       :class="{'is-active': isActive, 'is-disabled': disabled }">
    <div
            role="tab"
            :aria-expanded="isActive"
            :aria-controls="`el-collapse-content-${id}`"
            :aria-describedby="`el-collapse-content-${id}`"
    >
      <div
              class="el-collapse-item__header"
              @click="handleHeaderClick"
              role="button"
              :id="`el-collapse-head-${id}`"
              :tabindex="disabled ? undefined : 0"
              @keyup.space.enter.stop="handleEnterClick"
              :class="{
          'focusing': focusing,
          'is-active': isActive
        }"
              @focus="handleFocus"
              @blur="focusing = false"
      >

        <span style="margin-left: 15px;">
          <i
                  class="el-collapse-item__arrow el-icon-arrow-right"
                  :class="{'is-active': isActive}">
          </i>
          <!--<span>{{title}}</span>-->
          <athub-short-text :text="title" :show-max-length="76"></athub-short-text>
        </span>
        <div style="margin: 0 15px 0 auto;line-height: 100%;">
          <slot name="bar"></slot>
        </div>
      </div>
    </div>
    <el-collapse-transition>
      <div
              class="el-collapse-item__wrap"
              v-show="isActive"
              role="tabpanel"
              :aria-hidden="!isActive"
              :aria-labelledby="`el-collapse-head-${id}`"
              :id="`el-collapse-content-${id}`"
      >
        <div class="el-collapse-item__content">
          <slot></slot>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
  import ElCollapseTransition from 'element-ui/src/transitions/collapse-transition';
  import Emitter from 'element-ui/src/mixins/emitter';
  import {generateId} from 'element-ui/src/utils/util';
  import AthubShortText from "./athub-short-text";

  export default {
    name: 'AthubCollapseItem',

    componentName: 'AthubCollapseItem',

    mixins: [Emitter],

    components: {AthubShortText, ElCollapseTransition},

    data() {
      return {
        contentWrapStyle: {
          height: 'auto',
          display: 'block'
        },
        contentHeight: 0,
        focusing: false,
        isClick: false,
        id: generateId()
      };
    },

    inject: ['collapse'],

    props: {
      title: String,
      name: {
        type: [String, Number],
        default() {
          return this._uid;
        }
      },
      disabled: Boolean
    },

    computed: {
      isActive() {
        return this.collapse.activeNames.indexOf(this.name) > -1;
      }
    },

    methods: {
      handleFocus() {
        setTimeout(() => {
          if (!this.isClick) {
            this.focusing = true;
          } else {
            this.isClick = false;
          }
        }, 50);
      },
      handleHeaderClick() {
        if (this.disabled) return;
        this.dispatch('AthubCollapse', 'item-click', this);
        this.focusing = false;
        this.isClick = true;
      },
      handleEnterClick() {
        this.dispatch('AthubCollapse', 'item-click', this);
      }
    }
  };
</script>
<style scoped>
/*  .el-collapse-item__arrow {
    margin: 0 auto 0 8px;
  }*/
</style>